import AlexaI18nService from 'src/modules/alexaI18n/alexaI18nService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'ALEXAI18N_FORM';

const alexaI18nFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: alexaI18nFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AlexaI18nService.find(id);
      }

      dispatch({
        type: alexaI18nFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: alexaI18nFormActions.INIT_ERROR,
      });

      getHistory().push('/alexa-i18n');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: alexaI18nFormActions.CREATE_STARTED,
      });

      await AlexaI18nService.create(values);

      dispatch({
        type: alexaI18nFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.alexaI18n.create.success'),
      );

      getHistory().push('/alexa-i18n');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: alexaI18nFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: alexaI18nFormActions.UPDATE_STARTED,
      });

      await AlexaI18nService.update(id, values);

      dispatch({
        type: alexaI18nFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.alexaI18n.update.success'),
      );

      getHistory().push('/alexa-i18n');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: alexaI18nFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default alexaI18nFormActions;
